import limitValue from "../../../../utils/limit-value";
import precisePercents from "../../../../utils/precise-percents";
import round from "../../../../utils/round";
import onPause from "../on-property-percents/on-pause";
import getOverallPercents from "./get-overall-percents";

/**
 * Get percents
 * @param {PropertyValueProps | TimelineMapProps} property
 * @param {Number} startTime
 * @param {Number} now
 * @param {Boolean} enter
 * @param {Boolean} [spring]
 * @param {Number} [duration]
 */
const getPercents = (
  property,
  startTime,
  now,
  enter,
  spring = false,
  duration = 400
) => {
  let percents = 0;
  let rounded = 0;
  let precise = 0;

  const paused = property.get("paused");
  const delayed = property.get("delayed");
  const alternate = property.get("has-alternate");
  const last = property.get("percents-unlimited");

  if (enter) {
    const leaveOverall = /** @type {Number} */ (
      spring ? 0 : property.get("leave-overall")
    );

    rounded = round((now - startTime) / (duration * (1 - leaveOverall)));
    precise = precisePercents(rounded, last, true);
    percents = spring ? precise : limitValue(precise);

    if (isNaN(percents)) {
      percents = /** @type {Number} */ (property.get("leave-percents"));
    }

    const enterOverall = getOverallPercents(leaveOverall, percents, true);
    const overallNonLimited = getOverallPercents(leaveOverall, precise, true);

    if (!delayed) {
      property.set("enter-percents", percents);
      property.set("enter-overall", enterOverall);
      property.set("percents-overall", enterOverall);
      property.set("percents-unlimited", overallNonLimited);
    }
  } else {
    const enterOverall = /** @type {Number} */ (
      spring ? 1 : property.get("enter-overall")
    );

    rounded = round((now - startTime) / (duration * enterOverall || 1));
    precise = precisePercents(rounded, last, false);
    percents = spring ? precise : limitValue(precise);

    if (isNaN(percents)) {
      percents = /** @type {Number} */ (property.get("enter-percents"));
    }

    const leaveOverall = getOverallPercents(enterOverall, percents, false);
    const overallNonLimited = getOverallPercents(enterOverall, precise, false);

    if (!delayed) {
      property.set("leave-percents", percents);
      property.set("leave-overall", leaveOverall);
      property.set("percents-overall", leaveOverall);
      property.set("percents-unlimited", overallNonLimited);
    }
  }

  if (rounded >= 0) {
    property.set("delayed", false);
  }

  if (paused && rounded < 0) {
    onPause(property, enter);

    return alternate ? 0 : 1;
  }

  if (delayed) {
    percents = 0;
  }

  property.set("paused", false);

  return percents;
};

export default getPercents;
